// Surface Tension units with conversion factors to newton per meter (N/m)
export const surfaceTensionUnits = [
  { id: 'newton-per-meter', name: 'Newton per Meter', symbol: 'N/m', plural: 'Newtons per Meter', factor: 1 },
  { id: 'millinewton-per-meter', name: 'Millinewton per Meter', symbol: 'mN/m', plural: 'Millinewtons per Meter', factor: 1e-3 },
  { id: 'dyne-per-centimeter', name: 'Dyne per Centimeter', symbol: 'dyn/cm', plural: 'Dynes per Centimeter', factor: 1e-3 },
  { id: 'erg-per-square-centimeter', name: 'Erg per Square Centimeter', symbol: 'erg/cm²', plural: 'Ergs per Square Centimeter', factor: 1e-3 },
  { id: 'erg-per-square-millimeter', name: 'Erg per Square Millimeter', symbol: 'erg/mm²', plural: 'Ergs per Square Millimeter', factor: 0.1 },
  { id: 'pound-force-per-inch', name: 'Pound-force per Inch', symbol: 'lbf/in', plural: 'Pounds-force per Inch', factor: 175.126835 },
  { id: 'pound-force-per-foot', name: 'Pound-force per Foot', symbol: 'lbf/ft', plural: 'Pounds-force per Foot', factor: 14.5939029 },
  { id: 'gram-force-per-centimeter', name: 'Gram-force per Centimeter', symbol: 'gf/cm', plural: 'Grams-force per Centimeter', factor: 0.0980665 },
];

export const popularSurfaceTensionConversions = [
  { from: 'newton-per-meter', to: 'dyne-per-centimeter' },
  { from: 'dyne-per-centimeter', to: 'newton-per-meter' },
  { from: 'newton-per-meter', to: 'millinewton-per-meter' },
  { from: 'millinewton-per-meter', to: 'dyne-per-centimeter' },
  { from: 'pound-force-per-inch', to: 'newton-per-meter' },
  { from: 'newton-per-meter', to: 'pound-force-per-inch' },
];

export const getUnitById = (id) => surfaceTensionUnits.find(unit => unit.id === id);

export const convertSurfaceTension = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert surface tension units and learn the conversion formula.`;
};
